import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import { CustomTooltip } from "src/components/CustomTooltip";
import styles from "./Tooltip.module.css";

export const FormulaHeaderTooltipModule: TooltipContentModule = {
  type: "formula",
  priority: 3,
  shouldRender: (context: TooltipContext) => {
    return context.type === "formula" && !!context.metadata?.formula;
  },
  render: (context: TooltipContext) => {
    const { field, formattedValue, metadata } = context;
    const formula = metadata.formula;

    const content = (
      <div className={styles.tooltip_container}>
        <div className={styles.tooltip_header}>Formula Information</div>
        <div className={styles.tooltip_section}>
          <div className={styles.tooltip_row}>
            <div className={styles.tooltip_label}>Field</div>
            <span className={styles.tooltip_value}>{field?.target}</span>
          </div>

          <div className={styles.tooltip_row}>
            <div className={styles.tooltip_code}>{formula}</div>
          </div>
        </div>
      </div>
    );

    return (
      <CustomTooltip content={content} placement="right" size="medium">
        {context.children}
      </CustomTooltip>
    );
  },
};
